export { default } from "./accordion-item-content";
